// @flow
import React from "react";
import fileDownload from "js-file-download";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {
  /* Get inventorystock */
  function* getInventoryStock(action) {
    try {
      const response = yield call(
        api.inventory.getInventoryStock,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        if (action.query.indexOf("is_export") !== -1)
          fileDownload(response.data, `Inventory.csv`);
        yield put(Actions.getInventoryStockSuccess(response.data));
      } else {
        yield put(
          Actions.getInventoryStockFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getInventoryStockFailure(error));
    }
  }
  function* watchGetInventoryStock(): Generator<void, void, void> {
    yield takeLatest(Types.GET_INVENTORY_STOCK, getInventoryStock);
  }

  /* getInventoryWarehouse */
  function* getInventoryWarehouse(action) {
    try {
      const response = yield call(api.inventory.getInventoryWarehouse);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getInventoryWarehouseSuccess(response.data));
      } else {
        yield put(
          Actions.getInventoryWarehouseFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getInventoryWarehouseFailure(error));
    }
  }
  function* watchGetInventoryWarehouse(): Generator<void, void, void> {
    yield takeLatest(Types.GET_INVENTORY_WAREHOUSE, getInventoryWarehouse);
  }

  return {
    watchGetInventoryStock,
    watchGetInventoryWarehouse
  };
};



// WEBPACK FOOTER //
// ./src/sagas/InventorySaga.js